<template>
  <ul class="input-file__wrapper">
    <IcInputFileInput
      class="input-file"
      v-for="(file,idx) in files"
      :key="idx + file.name"
      :validator="v ? v.$each[idx] : null"
      v-model="files[idx]"
      @file:add="addFile"
      @file:remove="removeFile(idx)"
      :idx="idx"
    />
  </ul>
  
</template>

<script>
import has from "lodash/has";
import IcInputFileInput from "./InputFileInput";

const _ = { has };

export default {
  name: "IcInputFile",
  props: {
    value: {},
    name: {
      type: String,
      default: "files"
    },
    id: {
      type: String,
      required: true
    },
    prompt: {
      type: String,
      default: "Wybierz plik"
    },
    maxFiles: {
      type: Number,
      default: 5
    },
    v: {
      type: Object
    }
  },

  data() {
    return {
      files: [{}]
    };
  },
  computed: {
    selectedFiles: function() {
      return this.files.filter(v => v.name);
    }
  },
  methods: {
    addFile(data) {
      this.$set(this.files, data.idx, data.file);
      if (this.files.length < this.maxFiles) {
        this.files.push({});
      }
      this.$emit("input", this.selectedFiles);
      if (this.v) {
        this.v.$touch();
      }
    },
    removeFile(idx) {
      this.files.splice(idx, 1);
      if (this.files[this.files.length - 1].name) {
        this.files.push({});
      }
      this.$emit("input", this.selectedFiles);
      if (this.v) {
        this.v.$touch();
      }
    }
  },
  components: {
    IcInputFileInput
  }
};
</script>

<style lang="scss">
</style>
